import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { CmsPlanSwitch } from 'store/cms/models';
import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { targetPlanSwitchDetails } from 'store/plan-eligibility/models/target-plan-switch';

@Component({
    selector: 'xm-icop-plan-switch-promotions',
    templateUrl: 'icop-plan-switch-promotions.html',
    styleUrls: ['icop-plan-switch-promotions.scss'],
    standalone: false
})
export class XmICOPPlanSwitchPromotions implements OnDestroy, OnInit {
    public isIcopPlanSwitch: boolean = false;
    public legacyPromoDetails: targetPlanSwitchDetails;
    public alertIcon: MediaImageOptions;
    public dollarIcon: MediaImageOptions;
    public infoIcon: MediaImageOptions;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private config: IXMOptions;

    constructor(xmStore: XmStore, state: StateService, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { xmStore, state, config });
    }

    public ngOnInit(): void {
        this.isIcopPlanSwitch = this.config.ENABLE_ICOP_P1_PLANSWITCH;
        if (this.isIcopPlanSwitch) {
            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<targetPlanSwitchDetails>(targetPlanSwitchDetails), (legacyPromoDetails: targetPlanSwitchDetails) => {
                this.legacyPromoDetails = legacyPromoDetails;
            }));
            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsPlanSwitch>(CmsPlanSwitch), (result: CmsPlanSwitch) => {

                this.alertIcon = {
                    mobile: Cloudinary.generateMediaFromCms(result.alertIcon)
                };
                this.dollarIcon = {
                    mobile: Cloudinary.generateMediaFromCms(result.dollarIcon)
                };
                this.infoIcon = {
                    mobile: Cloudinary.generateMediaFromCms(result.infoIconGrey)
                };
            }));
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public getPromoIcon(iconType: string): MediaImageOptions {
        switch (iconType?.toLowerCase()) {
            case 'warning':
                return this.alertIcon;
            case 'offer':
                return this.infoIcon;
            case 'savings':
                return this.dollarIcon;
            default:
                return this.alertIcon;
        }
    }
}
